import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';

@Component({
    selector: 'app-single-card',
    standalone: true,
    templateUrl: './single-card.component.html',
    styleUrls: ['./single-card.component.scss'],
    imports: [DxScrollViewModule]
})
export class SingleCardComponent {
    constructor() {}
}

@NgModule({
    imports: [CommonModule, DxScrollViewModule, SingleCardComponent],
    exports: [SingleCardComponent]
})
export class SingleCardModule {}
